import { date, object } from 'serializr';
import type { IMoney } from '@type/IMoney';
import type { IPrice } from '@type/IPrice';
import { createModelSchema } from '@services/EntityCache';
import { Money } from './Money';

export class Price implements IPrice {
  date!: Date;

  price!: IMoney;
}

export const priceSchema = createModelSchema(Price, {
  date: date(),
  price: object(Money)
});
